import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ContentStateService } from '../../../content-state.service';
import { Chunk } from '../../chunk.dto';

@Component({
  selector: 'app-select-chunk',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  template: `
    <div class="interactive-item" (click)="selectChunk()">
      <div class="interactive-item__content">
        <mat-icon class="interactive-item__icon" aria-hidden="true">done_all</mat-icon>
        <span class="interactive-item__text">{{ 'Global.MultiSelect' | translate }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectChunkComponent {
  @Input() chunk: Chunk;
  @Output() actionTriggered = new EventEmitter<void>();

  private contentState = inject(ContentStateService);

  selectChunk(): void {
    this.actionTriggered.emit(); // Close the parent overlay immediately

    if (!this.chunk) {
      return;
    }

    this.contentState.toggleChunkSelection(this.chunk._id);
  }
}
